// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c70d4fde2e9ccba49e7b55ba10c7cbe11579c914/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};